<div class="chatbot_unread-icon">
  <div class="pulse-wrapper">
    <div class="pulseOuter"></div>
    <div class="pulseInner"></div>
    <div class="core"></div>
  </div>
</div>
